export default "/images/379f3ec84f31ac4677e6948865ad0e98.jpg";